// extracted by mini-css-extract-plugin
export default {"rotatingText":"styles_rotatingText__MDIbo"};